export const getNumSteps = (
  min: number,
  max: number,
  step: number
): number => {
  if (step <= 0) {
    return 1
  }
  return Math.max(1, Math.round((max - min) / step))
}

export const getDefaultTrackStep = (
  min: number,
  max: number,
  step: number,
  minPercentage: number,
  maxPercentage: number
): number => {
  return (maxPercentage - minPercentage) / getNumSteps(min, max, step)
}

const stepIndexToValue = (
  index: number,
  min: number,
  max: number,
  step: number,
  numSteps: number
): number => {
  if (index <= 0) {
    return min
  }
  if (index >= numSteps) {
    return max
  }
  return Math.min(max, min + index * step)
}

// On a fine step grid the last stop is sub-pixel, so dragging to the end lands
// just short of max.
export const DEFAULT_MAX_SNAP_PERCENT = 10

// Capped at one step so the zone can never swallow the stop below max.
const getMaxSnapRatio = (numSteps: number, maxSnapPercent: number) => {
  return Math.min(Math.max(maxSnapPercent, 0) / 100, 1 / numSteps)
}

export const resolveDefaultValue = (
  trackValue: number,
  min: number,
  max: number,
  step: number,
  minPercentage: number,
  maxPercentage: number,
  maxSnapPercent: number = DEFAULT_MAX_SNAP_PERCENT
): number => {
  const numSteps = getNumSteps(min, max, step)
  const trackRange = maxPercentage - minPercentage
  const ratio = trackRange === 0 ? 0 : (trackValue - minPercentage) / trackRange

  if (ratio >= 1 - getMaxSnapRatio(numSteps, maxSnapPercent)) {
    return max
  }

  const index = Math.min(numSteps, Math.max(0, Math.round(ratio * numSteps)))
  return stepIndexToValue(index, min, max, step, numSteps)
}
